import { TimelineSection } from '@fmg-packages/common-components';

type Action =
  | { type: 'ADD_EDIT_SECTION'; payload: TimelineSection }
  | { type: 'REMOVE_EDIT_SECTION'; payload: TimelineSection };

type State = TimelineSection[];

export function editTimelineSectionsReducer(state: State, action: Action): State {
  switch (action.type) {
    case 'ADD_EDIT_SECTION':
      return [...state, action.payload];
    case 'REMOVE_EDIT_SECTION':
      return state.filter((timelineSection) => timelineSection.id !== action.payload.id);
    default: {
      const x: never = action;
      return x;
    }
  }
}
